/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateOrderDto
 */
export interface CreateUpdateOrderDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrderDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrderDto
     */
    projectId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrderDto
     */
    teamId: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOrderDto
     */
    addTeamToEmails: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateOrderDto
     */
    emails: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateOrderDto
     */
    orderEstimateItemsIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUpdateOrderDto
     */
    orderEmployeesIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrderDto
     */
    pathPhaseDictionaryId?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateOrderDto
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateOrderDto
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateOrderDto
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateOrderDto
     */
    status?: CreateUpdateOrderDtoStatusEnum;
}


/**
 * @export
 */
export const CreateUpdateOrderDtoStatusEnum = {
    New: 'New',
    Accepted: 'Accepted',
    Rejected: 'Rejected'
} as const;
export type CreateUpdateOrderDtoStatusEnum = typeof CreateUpdateOrderDtoStatusEnum[keyof typeof CreateUpdateOrderDtoStatusEnum];


/**
 * Check if a given object implements the CreateUpdateOrderDto interface.
 */
export function instanceOfCreateUpdateOrderDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "projectId" in value;
    isInstance = isInstance && "teamId" in value;
    isInstance = isInstance && "addTeamToEmails" in value;
    isInstance = isInstance && "emails" in value;
    isInstance = isInstance && "orderEstimateItemsIds" in value;
    isInstance = isInstance && "orderEmployeesIds" in value;

    return isInstance;
}

export function CreateUpdateOrderDtoFromJSON(json: any): CreateUpdateOrderDto {
    return CreateUpdateOrderDtoFromJSONTyped(json, false);
}

export function CreateUpdateOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateOrderDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'projectId': json['projectId'],
        'teamId': json['teamId'],
        'addTeamToEmails': json['addTeamToEmails'],
        'emails': json['emails'],
        'orderEstimateItemsIds': json['orderEstimateItemsIds'],
        'orderEmployeesIds': json['orderEmployeesIds'],
        'pathPhaseDictionaryId': !exists(json, 'pathPhaseDictionaryId') ? undefined : json['pathPhaseDictionaryId'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'active': !exists(json, 'active') ? undefined : json['active'],
        'status': !exists(json, 'status') ? undefined : json['status'],
    };
}

export function CreateUpdateOrderDtoToJSON(value?: CreateUpdateOrderDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'projectId': value.projectId,
        'teamId': value.teamId,
        'addTeamToEmails': value.addTeamToEmails,
        'emails': value.emails,
        'orderEstimateItemsIds': value.orderEstimateItemsIds,
        'orderEmployeesIds': value.orderEmployeesIds,
        'pathPhaseDictionaryId': value.pathPhaseDictionaryId,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'active': value.active,
        'status': value.status,
    };
}

